import { render, staticRenderFns } from "./disclaimerModal.vue?vue&type=template&id=f568ffd8&"
import script from "./disclaimerModal.vue?vue&type=script&lang=js&"
export * from "./disclaimerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports